export default "__VITE_ASSET__15a427cc__"